let nextErrorId = 0;
export class Error {
    constructor(options) {
        this.id = nextErrorId++;
        this.dateTime = Date.now();
        this.message = 'Error';
        this.showNotification = true;
        this.error = options.error;
        this.message = options.message || (this.error ? this.error.message : this.message);
        this.source = options.source;
        this.redirect = options.redirect;
        this.redirectRoute = options.redirectRoute;
        if (options.showNotification === false || !this.message) {
            this.showNotification = false;
        }
    }
}
//# sourceMappingURL=error.js.map